import { Map } from 'immutable';

/**
 * Custom messages for transpennine
 */

module.exports = new Map({
    'app.owner': 'TransPennine Express',
    'app.owner.toc': 'TPE',
    'app.owner.short': 'TransPennine Express',
    'app.owner.appName': 'TransPennine Express',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.nav.reservations': 'Reservations',

    'login.username': 'Email address',
    'customerdetails.email': 'Email address',
    'promotion.tocFamily.email.label': 'Email address',

    'ontrackapp.widget.title': 'Meet the {brand} App',

    'preference-centre.privacy-notice': '_',
    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TransPennine Express. Please log in or use a different email address.',

    'booking.delivery.notAvailable.paper': 'Sorry. There are no collection or delivery options available for your order. This may be because you are attempting to buy a paper ticket within { todCollectionMinimumTime } of your time of departure. It may also be because you have bike reservations and the only available delivery method is eTicket.',
    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the TransPennine Express app.',
});



// WEBPACK FOOTER //
// ./src/messages/transpennine.js